var map = {
	"./BrandsPageExtensions": 21285,
	"./BrandsPageExtensions.ts": 21285,
	"./CategoryDetailsPageExtensions": 76471,
	"./CategoryDetailsPageExtensions.ts": 76471,
	"./FooterExtensions": 21019,
	"./FooterExtensions.ts": 21019,
	"./HeaderExtensions": 26049,
	"./HeaderExtensions.ts": 26049,
	"./ProductListPageExtensions": 50922,
	"./ProductListPageExtensions.ts": 50922,
	"./SignInPageExtensions": 49985,
	"./SignInPageExtensions.ts": 49985,
	"./readme.md": 51681
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60069;